import { render, staticRenderFns } from "./StatusRequirementsComponent.vue?vue&type=template&id=9ac6a33c&"
import script from "./StatusRequirementsComponent.vue?vue&type=script&lang=ts&"
export * from "./StatusRequirementsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports